import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import Typography from '../../../../Typography';
import { dataTableNoData, dataTableSection } from '../../constants';
import { useTableContext } from '../../context';
import { NoDataImage } from './Image';
import { NoDataWrapper } from './styled';
export const NoData = memo(function NoData({ className, message, action, image = _jsx(NoDataImage, {}), dataTestId }) {
    const { compact } = useTableContext();
    return (_jsxs(NoDataWrapper, { className: className, "$compact": compact, ...dataTableSection, ...dataTableNoData, "data-testid": dataTestId ?? 'there-are-no-entries', children: [image, _jsx(Typography.Title, { children: message }), action || null] }));
});
